/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

// Themes
export const THEMES = {
  DEFAULT: 'DEFAULT',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  INDIGO: 'INDIGO',
}

export const getStatColumns = (
  t: (key: string, defaultValue?: string) => string,
) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue', 'Total Revenue'),
    AVG_STORE_REVENUE: t('statColumns.avgStoreRevenue', 'Avg Store Revenue'),
    INSIDE_SALES: t('statColumns.insideSales', 'Inside Sales'),
    COMPLIANCE: t('statColumns.compliance', 'Compliance'),
    EMPTY_FACINGS: t('statColumns.emptyFacings', 'Empty Facings'),
    RESTOCK_COMPLETION: t(
      'statColumns.restockCompletion',
      'Restock Completion',
    ),
    TASK_COMPLETION: t('statColumns.taskCompletion', 'Task Completion'),
  }
}

export const getProductStatColumns = (
  t: (key: string, defaultValue?: string) => string,
) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue', 'Total Revenue'),
    TOTAL_EARNINGS: t('statColumns.totalMargin', 'Total Margin'),
    VOLUME: t('statColumns.volume', 'Volume'),
    FACINGS: t('statColumns.facings', 'Facings'),
    EMPTY_FACINGS: t('statColumns.emptyFacings', 'Empty Facings'),
    REVENUE_PER_FACING: t('statColumns.revenuePerFacing', 'Revenue Per Facing'),
    EARNINGS_PER_FACING: t('statColumns.marginPerFacing', 'Margin Per Facing'),
  }
}

// Invites
// TODO: figure out a way to do this without hardcoding
export const MANAGER = 'Manager'
export const ADMIN = 'Admin'
export const EMPLOYEE = 'Employee'
export const MANAGER_INVITE_ROLES = [MANAGER, EMPLOYEE]
export const ADMIN_INVITE_ROLES = [ADMIN, MANAGER, EMPLOYEE]
export const MANAGER_EDIT_ROLES = [EMPLOYEE]
export const ADMIN_EDIT_ROLES = [ADMIN, MANAGER, EMPLOYEE]

export const getRevenueDetailsStatColumns = (
  t: (key: string, defaultValue?: string) => string,
) => {
  return {
    TOTAL_REVENUE: t('statColumns.totalRevenue', 'Total Revenue'),
    INSIDE_SALES: t('statColumns.insideSales', 'Inside Sales'),
    OUTSIDE_SALES: t('statColumns.outsideSales', 'Outside Sales'),
    FUEL_VOLUME: t('statColumns.fuelVolume', 'Fuel Volume'),
  }
}

export const DEFAULT_AVATAR = '/static/img/avatars/default.jpg'
